<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="日期">
                <el-date-picker
                        v-model="formInline.searchDate"
                        align="right"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="findList">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="AccessLogsList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="action" label="接口"></el-table-column>
            <el-table-column prop="beginTime" label="访问时间"></el-table-column>
            <el-table-column prop="runTimes" label="耗时(毫秒)"></el-table-column>
            <el-table-column prop="ip" label="IP"></el-table-column>
            <el-table-column label="日志">
                <template slot-scope="scope">
                    <el-button @click="handleCopy(scope.row.message)">复制</el-button>
                </template>
            </el-table-column>
<!--            <el-table-column prop="operator" label="操作人"></el-table-column>-->
            <el-table-column label="参数">
                <template slot-scope="scope">
                    <el-button @click="handleCopy(scope.row.params)">复制</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="url" label="完整路径"></el-table-column>
            <el-table-column prop="customerId" label="客户ID"></el-table-column>
<!--            <el-table-column prop="userAgent" label="浏览器"></el-table-column>-->
<!--            <el-table-column prop="userId" label="userId"></el-table-column>-->
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findAccessLogs} from '@/api/api';
    export default {
        data() {
            return {
                AccessLogsList: [],
                loading: true,
                formInline: {
                    searchDate: '',
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },
        //挂载时候执行
        mounted(){
            let yesterday = new Date();
            yesterday.setTime(yesterday.getTime()-24*60*60*1000);
            this.formInline.searchDate = yesterday.getFullYear()+"-" + (yesterday.getMonth()+1) + "-" + yesterday.getDate();//默认昨天
            //初始化首页数据
            this.findList();
        },
        methods: {
            findList(){
                if(this.formInline.searchDate == null || this.formInline.searchDate ==''){
                    this.$message({
                        showClose: true,
                        message: '请选择日期',
                        type: 'error'
                    });
                    return;
                }
                findAccessLogs(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.AccessLogsList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleCopy(text){
                this.$copyText(this.byteToString(text)).then(function (e) {
                    this.$message({
                        message: '复制成功',
                        type: 'success'
                    });
                }, function (e) {
                    this.$message.error('复制失败');
                })
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/monitor/AccessLogsList.vue